import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../user/_services/authentication.service';
import { Router } from '@angular/router';
import { FORM_MSGS } from '../_common/product-config';
import { CommonService } from '../_services/common.service';
import { StatusCode } from '../_common/_enum/module.enum';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    private whiteListAPI500 = ["/messages", "/user/change", "/lossrunreport", "/documentdownload", "confirmrate", "quoteissued", "/submission/sics/search", "submission/naics/search", "submission/list", "issuance/producersbyniches", "issuance/productsunderwriters", "/resendactivation", "/issuance/account/clear", "/search/typeahead", "event", "/activateuser", "document/list", "policy/document/download", "user/mfa/update", "/issuance/verify", "/issuance/getpersonlist"];

    constructor(private authenticationService: AuthenticationService, private router: Router, private commonService: CommonService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let exceptionFor500 = false;
        this.whiteListAPI500.some(apiUrl => {
            exceptionFor500 = request.url.includes(apiUrl);
            return exceptionFor500;
            
        });
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401 && !request.url.includes("/mfa")) {
                console.log("Not authorized user.. Logging you out!")
                // auto logout if 401 response returned from api
                //this.authenticationService.logout();
                this.commonService.removeData();
                this.commonService.removeLocalStorageData();
                this.authenticationService.setUserLoggedIn(false);
                this.router.navigate(['/login'], {queryParams: { returnUrl: this.router.url }, state: {warningMessage: FORM_MSGS.SessionTimeout}});
            }else if (err.status != StatusCode.NoAccess && !this.router.url.includes("/login") && !exceptionFor500) {
                if(request.url.includes("/refresh")){
                    console.log("error while refreshing token. Session is already timed out!");
                    this.authenticationService.logout().subscribe(()=>{
                        this.router.navigate(["/login"], {queryParams: { returnUrl: this.router.url }, state: {warningMessage: FORM_MSGS.SessionTimeout}})
                    });
                }else{
                    console.log("Server Error!")
                    // show Error page if gets !405 error from api
                    this.router.navigate(['/error']);
                }
            }
            
            return throwError(err);
        }))
    }
}